import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {}

export const StyledMobileIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7 2C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2H7ZM17 4H7V17H17V4ZM14 19H10V20H14V19Z'
            />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    height: 24px;
    width: 24px;
    fill: ${p => p.theme.playColor};
`
